import React from 'react'
import { Platform } from 'react-native'
import { SvgXml } from 'react-native-svg'

/* Icon raw xmls (as functions with param color) */
import add from '@lib/icons/add'
import apps from '@lib/icons/apps'
import arrowBack from '@lib/icons/arrowBack'
import arrowDropDown from '@lib/icons/arrowDropDown'
import arrowDropUp from '@lib/icons/arrowDropUp'
import arrowForward from '@lib/icons/arrowForward'
import chat from '@lib/icons/chat'
import check from '@lib/icons/check'
import checkCircleOutline from '@lib/icons/checkCircleOutline'
import chevronLeft from '@lib/icons/chevronLeft'
import chevronRight from '@lib/icons/chevronRight'
import close from '@lib/icons/close'
import expandMore from '@lib/icons/expandMore'
import expandLess from '@lib/icons/expandLess'
import favorite from '@lib/icons/favorite'
import filterList from '@lib/icons/filterList'
import fullscreen from '@lib/icons/fullscreen'
import fullscreenExit from '@lib/icons/fullscreenExit'
import highlightOff from '@lib/icons/highlightOff'
import info from '@lib/icons/info'
import menu from '@lib/icons/menu'
import moreVert from '@lib/icons/moreVert'
import questionAnswer from '@lib/icons/questionAnswer'
import refresh from '@lib/icons/refresh'
import reportProblem from '@lib/icons/reportProblem'
import search from '@lib/icons/search'

interface IconProps {
  color?: string
  size?: number
}

type BaseIconProps = {
  xml: (color: string) => string
  color?: string
  size?: number
}

/* Base Icon */
const BaseIcon = ({ color = '#000', size = 30, xml }: BaseIconProps) => {
  if (Platform.OS === 'web') {
    const image = xml(color)
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={`data:image/svg+xml;utf8,${encodeURIComponent(image)}`}
            style={{ transform: `scale(${size / 24})` }}
          />
        </div>
    )
  }
  return (
    <SvgXml
      xml={xml(color)}
      width={`${size}`}
      height={`${size}`} />
  )
}

/**
 * Custom icons
 *  */
export const AddIcon = (props: IconProps) => <BaseIcon xml={add} {...props} />
export const AppsIcon = (props: IconProps) => <BaseIcon xml={apps} {...props} />
export const ArrowBackIcon = (props: IconProps) => <BaseIcon xml={arrowBack} {...props} />
export const ArrowDropDownIcon = (props: IconProps) => <BaseIcon xml={arrowDropDown} {...props} />
export const ArrowDropUpIcon = (props: IconProps) => <BaseIcon xml={arrowDropUp} {...props} />
export const ArrowForwardIcon = (props: IconProps) => <BaseIcon xml={arrowForward} {...props} />
export const CheckIcon = (props: IconProps) => <BaseIcon xml={check} {...props} />
export const ChatIcon = (props: IconProps) => <BaseIcon xml={chat} {...props} />
export const CheckCircleOutlineIcon = (props: IconProps) => <BaseIcon xml={checkCircleOutline} {...props} />
export const ChevronLeftIcon = (props: IconProps) => <BaseIcon xml={chevronLeft} {...props} />
export const ChevronRightIcon = (props: IconProps) => <BaseIcon xml={chevronRight} {...props} />
export const CloseIcon = (props: IconProps) => <BaseIcon xml={close} {...props} />
export const ExpandLessIcon = (props: IconProps) => <BaseIcon xml={expandLess} {...props} />
export const ExpandMoreIcon = (props: IconProps) => <BaseIcon xml={expandMore} {...props} />
export const FavoriteIcon = (props: IconProps) => <BaseIcon xml={favorite} {...props} />
export const FilterListIcon = (props: IconProps) => <BaseIcon xml={filterList} {...props} />
export const FullscreenIcon = (props: IconProps) => <BaseIcon xml={fullscreen} {...props} />
export const FullscreenExitIcon = (props: IconProps) => <BaseIcon xml={fullscreenExit} {...props} />
export const HighlightOffIcon = (props: IconProps) => <BaseIcon xml={highlightOff} {...props} />
export const InfoIcon = (props: IconProps) => <BaseIcon xml={info} {...props} />
export const MenuIcon = (props: IconProps) => <BaseIcon xml={menu} {...props} />
export const MoreVertIcon = (props: IconProps) => <BaseIcon xml={moreVert} {...props} />
export const QuestionAnswerIcon = (props: IconProps) => <BaseIcon xml={questionAnswer} {...props} />
export const RefreshIcon = (props: IconProps) => <BaseIcon xml={refresh} {...props} />
export const ReportProblemIcon = (props: IconProps) => <BaseIcon xml={reportProblem} {...props} />
export const SearchIcon = (props: IconProps) => <BaseIcon xml={search} {...props} />
